/**
 * Tanstack Query v5 хук для GET /v1/platform/me.
 *
 * Server-state ТОЛЬКО через React Query (патент проекта: не useEffect+useState
 * для фетча). Включается лишь при наличии токена.
 */
import { useQuery } from '@tanstack/react-query';
import { fetchPlatformMe, type PlatformMeResponse } from './platform-me.js';

export const PLATFORM_ME_KEY = ['platform', 'me'] as const;

export interface UsePlatformMeOptions {
  /** Включать запрос только при наличии токена. */
  enabled?: boolean;
}

export function usePlatformMe(options: UsePlatformMeOptions = {}) {
  return useQuery<PlatformMeResponse>({
    queryKey: PLATFORM_ME_KEY,
    queryFn: fetchPlatformMe,
    enabled: options.enabled ?? true,
    staleTime: 60_000,
  });
}
